import { Component } from "@angular/core";
import { Router } from "@angular/router";

import { ApiService } from "src/app/api.service";
declare const BrandVars;

@Component({
	selector: "app-login",
	templateUrl: "./login.component.html",
	styleUrls: ["./login.component.scss"]
})
export class LoginComponent {
	public brand = BrandVars;
	email = "";
	password = "";
	mfaCode = "";
	showMfa = false;

	errormessage?: string;

	constructor(public router: Router, private api: ApiService) { }

	async Login() {
		this.errormessage = undefined;
		try {
			await this.api.Login(this.email, this.password, this.showMfa ? this.mfaCode : undefined, true);
			this.router.navigate(["dash"]);
		} catch (err) {
			if (err && err.status && err.status === 401) {
				if (err.error?.message === "MFA code is required") {
					this.showMfa = true;
					setTimeout(() => {
						document.getElementById("mfa").focus();
					}, 100);
				} else if (err.error?.message === "All admins must have MFA enabled to log in") {
					this.errormessage = "Admins must have MFA enabled to log in";
				} else {
					if (this.showMfa) {
						this.errormessage = "Invalid MFA code";
					} else {
						this.errormessage = "Invalid username or password";
					}
				}
			} else {
				this.errormessage = "Login failed";
			}
		}
	}

	CancelMfa() {
		this.mfaCode = "";
		this.showMfa = false;
	}
}
